import { getBridgeRoot } from '../../files/cwd/index.js';
import { discoverSkillLayoutRootsAsync } from '../../skills/discovery.js';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { MessageHandlerDeps } from '../message-handler-deps.js';
import type { ApiToBridgeSkillLayoutRequestMessage } from '../../types/api-to-bridge-messages.js';

export function handleSkillLayoutRequest(msg: ApiToBridgeSkillLayoutRequestMessage, deps: MessageHandlerDeps): void {
  const id = typeof msg.id === 'string' ? msg.id : '';
  void (async () => {
    const socket = deps.getWs();
    const roots = await discoverSkillLayoutRootsAsync(getBridgeRoot());
    if (socket) {
      sendWsMessage(socket, { type: 'skill_layout_response', id, roots });
    }
  })();
}
